// 引入各种业务的js
import hardware from "./hardware.js"; // 硬件相关
export default {
    hardware,
}